import {connect} from "react-redux";
import Table from "../../../../components/coreUiTable/Table"
import React from "react";
import { dataForStudioInfoTables, toPercent } from "../utils/dataForTables";

export default connect(state => {
  const {tableInfo} = state.studioInfo.salesActivityRevenue;

  return {
    table: tableInfo,
    ...dataForStudioInfoTables,
    itemsPerPage: 3,
    scopedSlots: {
      ...dataForStudioInfoTables.scopedSlots,
      "%": (item)=>{
        const percent = toPercent(item["%"]);
        return <td >{percent}</td>
      },
    }
  };
})(Table);
